<template>
  <div class="container-fluid">
    <div class="row bg-white p-3 rounded">
      <div class="col-md-12 text-center profile">
        <div class="overlay">
          <div class="about d-flex flex-column">
            <h4>Kim Sarah</h4> <span>Software Developer</span>
          </div>
          <ul class="social-icons">
            <li><i class="fa fa-facebook"></i></li>
            <li><i class="fa fa-linkedin"></i></li>
            <li><i class="fa fa-twitter"></i></li>
            <li><i class="fa fa-instagram"></i></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'witnessDetails',
  data() {
    return {}
  },
  computed: {},
  methods: {}

}
</script>

<style>
.witness1 {
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
}

.name h2 {
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
}

.profile-image img {
  width: 250px;
  height: 250px;
  border-radius: 20px 0 20px 0;
  border: 2px solid deepskyblue;
}

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #000
}

.profile {
  position: relative;
  width: 300px;
  height: 350px;
  background: url("https://i.imgur.com/sAtgYjl.jpg");
  background-size: cover;
  cursor: pointer;
  border: 12px;
  border-top-right-radius: 35px !important;
  border-radius: 6px
}

.overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  cursor: pointer;
  opacity: 0;
  transition: all 1s;
  border-top-right-radius: 35px !important;
  border-radius: 6px
}

.profile:hover .overlay {
  opacity: 2
}

.social-icons {
  display: flex;
  list-style: none;
  bottom: 10px;
  position: absolute;
  text-align: center;
  justify-content: center;
  left: 22px
}

.social-icons li {
  width: 25px;
  height: 25px;
  border: 1px solid #eee;
  padding: 20px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 5px;
  transition: all 1s
}

.social-icons li:hover {
  background: #fff;
  color: #000
}

.overlay .about {
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  top: 40%;
  color: #fff;
  flex: column;
}
</style>